// extracted by mini-css-extract-plugin
export default {"nav":"j_1","logo":"j_B","search":"j_2"};